import { render, staticRenderFns } from "./ContributorAssignedToMyselfMessage.vue?vue&type=template&id=7bce7c0e"
import script from "./ContributorAssignedToMyselfMessage.vue?vue&type=script&lang=js"
export * from "./ContributorAssignedToMyselfMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports